import { View, Text } from "react-native";
import { EMBER } from "../../../onboarding/theme";
import { semanticColors } from "@louise/theme/tokens";

type SummaryItem = { title: string; description: string };

export default function QuickSummaryCard({ items }: { items: SummaryItem[] }) {
  return (
    <View
      style={{
        flexDirection: "row",
        borderRadius: 16,
        padding: 20,
        marginBottom: 24,
        backgroundColor: semanticColors.surface.subtle,
        overflow: "hidden",
      }}
    >
      <View style={{ flex: 1 }}>
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 13,
            fontWeight: "500",
            color: EMBER.colors.textMid,
            marginBottom: 14,
          }}
        >
          Key takeaways
        </Text>

        {items.map((item, i) => (
          <View
            key={i}
            style={{
              flexDirection: "row",
              gap: 12,
              alignItems: "flex-start",
              marginBottom: i < items.length - 1 ? 14 : 0,
            }}
          >
            {/* Numbered circle */}
            <View
              style={{
                width: 22,
                height: 22,
                borderRadius: 11,
                backgroundColor: semanticColors.accent.tint,
                alignItems: "center",
                justifyContent: "center",
                marginTop: 1,
              }}
            >
              <Text
                className="font-dm-sans"
                style={{
                  fontSize: 11,
                  fontWeight: "700",
                  color: EMBER.colors.warm,
                }}
              >
                {i + 1}
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text
                className="font-dm-sans"
                style={{
                  fontSize: 14,
                  fontWeight: "600",
                  color: EMBER.colors.text,
                  lineHeight: 20,
                }}
              >
                {item.title}
              </Text>
              <Text
                className="font-dm-sans"
                style={{
                  fontSize: 13,
                  color: EMBER.colors.textMid,
                  lineHeight: 19,
                  marginTop: 2,
                }}
              >
                {item.description}
              </Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
}
